<template>
  <el-container>
    <el-dialog
        :title="title"
        :visible.sync="addStaff"
        width="30%"
        :close-on-click-modal=false
        :before-close="handleDialogClose"
    >
      <el-form
          ref="staffForm"
          :model="form"
          :rules="rules"
          label-width="120px"
          class="demo-ruleForm"
          align="left"
      >
        <el-form-item label="组织机构" prop="orgCode" v-if="orgType == 1">
          <el-select
              placeholder="组织机构"
              size="small"
              v-model="form.orgCode"
              @change="changeOrgAdd"
              style="margin-right: 10px; width: 100%"
          >
            <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色:" prop="roleIdList">
          <el-select
              v-model="form.roleIdList"
              multiple
              style="width: 100%"
              size="small"
              @change="changeRole"
              placeholder="请选择"
          >
            <el-option
                v-for="item in roleList"
                :key="item.roleId"
                :label="item.roleName"
                :value="item.roleId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名:" prop="userName">
          <el-input
              v-model="form.userName"
              size="small"
              :disabled="isUpdate"
              placeholder="用户名(6-20数字、字母、下划线)"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password" v-if="!isUpdate">
          <el-input
              type="password"
              size="small"
              v-model="form.password"
              placeholder="密码(6-16位数字和字母组合)"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="confirmPassword" v-if="!isUpdate">
          <el-input
              type="password"
              size="small"
              v-model="form.confirmPassword"
              placeholder="密码(6-16位数字和字母组合)"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名:" prop="realName">
          <el-input v-model="form.realName" placeholder="姓名" size="small"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <el-input v-model="form.phone" size="small" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:" prop="email">
          <el-input v-model="form.email" placeholder="邮箱" size="small"></el-input>
        </el-form-item>
        <el-form-item label="学历:" prop="education">
          <el-select
              v-model="form.education"
              clearable
              placeholder="学历"
              size="small"
              style="width: 70%"
          >
            <el-option label="高中" value="高中"></el-option>
            <el-option label="中专" value="中专"></el-option>
            <el-option label="职高" value="职高"></el-option>
            <el-option label="大专，高职" value="大专，高职"></el-option>
            <el-option label="本科" value="本科"></el-option>
            <el-option label="硕士" value="硕士"></el-option>
            <el-option label="博士" value="博士"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联课程:" v-if="showCourse" prop="courseIdList">
          <el-select
              v-model="form.courseIdList"
              clearable
              size="small"
              placeholder="请选择"
              multiple
              style="width: 100%"
          >
            <el-option
                v-for="item in courseList"
                :key="item.courseId"
                :label="item.name"
                :value="item.courseId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="代理机构:" v-if="showAgents" prop="agentsList">
          <el-select
              v-model="form.originSource"
              clearable
              size="small"
              placeholder="请选择"
              style="width: 100%"
          >
            <el-option
                v-for="item in agentsList"
                :key="item.agentCode"
                :label="item.agentDes"
                :value="item.agentCode"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="直播间:" prop="liveUrl" v-if="showLiveUrl">
          <el-input v-model="form.liveUrl" placeholder="直播间" size="small"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveStaff('staffForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
        <el-row :gutter="0" justify="center">
          <el-col :span="4" class="cls-col">
            <el-form-item label="用户名" prop="userName">
              <el-input v-model="searchData.userName" placeholder="用户名" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="姓名" prop="realName">
              <el-input v-model="searchData.realName" placeholder="姓名" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="手机号" prop="phone">
              <el-input v-model="searchData.phone" placeholder="手机号" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col" v-if="orgType == 1">
            <el-form-item label="组织机构" prop="orgCode">
              <el-select
                  placeholder="组织机构"
                  clearable
                  size="small"
                  v-model="searchData.orgCode"
                  @change="changeLecturer"
                  style="margin-right: 10px; width: 100%"
              >
                <el-option
                    v-for="o in org"
                    :label="o.organizationName"
                    :value="o.orgCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4" class="cls-col">
            <el-form-item label="状态" clearable prop="status">
              <el-select
                  v-model="searchData.status"
                  clearable
                  placeholder="状态"
                  size="small"
                  style="width: 100%"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="停用" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item>
            <el-button
                type="primary"
                plain
                size="small"
                icon="el-icon-search"
                @click="onSubmit()"
            >查询
            </el-button>
          </el-form-item>
        </el-row>
      
      </el-form>
      <el-button
          type="success"
          icon="el-icon-circle-plus-outline"
          size="small"
          round
          @click="addStaff = true,title='添加用户',isUpdate=false"
          class="but-cls"
      >添加
      </el-button>
      <el-button
          type="danger"
          icon="el-icon-delete"
          size="small"
          round
          @click="deleteMore"
          class="but-cls"
      >删除
      </el-button>
      <el-table
          :data="staffData"
          border
          highlight-current-row
          v-loading="loading"
          style="width: 100%"
          @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50" fixed="left"></el-table-column>
        <el-table-column prop="userName" label="用户名" width="230" fixed="left"></el-table-column>
        <el-table-column prop="realName" label="姓名" width="200"></el-table-column>
        <el-table-column prop="orgName" label="组织机构"></el-table-column>
        <el-table-column prop="phone" label="手机号" width="200"></el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="2"
                @change="updateUserState(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button
                @click="restPWD(scope.$index, scope.row)"
                type="text"
                size="small"
            >重置密码
            </el-button>
            <el-button
                @click="updateStaff(scope.$index, scope.row)"
                type="text"
                size="small"
            >修改
            </el-button>
            <el-button
                @click="deleteStaff(scope.$index, scope.row)"
                type="text"
                size="small"
            >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          style="margin-top: 10px; float: right; margin-right: 10px"
      ></el-pagination>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js';
  import validate from '@/api/validate.js';

  const form = {
    userName: '',
    orgCode: '',
    realName: '',
    phone: '',
    email: '',
    education: '',
    status: 1,
    roleIdList: [],
    courseIdList: [],
    password: '',
    confirmPassword: '',
    liveUrl: '',
    originSource: ''
  };

  export default {
    data() {
      return {
        org: [],
        orgType: '',
        loading: true,
        form: JSON.parse(JSON.stringify(form)),
        searchData: {
          orgCode: '',
          page: 1,
          phone: '',
          realName: '',
          size: 0,
          status: '',
          userName: ''
        },
        multipleSelection: [],
        rules: {
          userName: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            {validator: validate.validateUserName, trigger: 'blur'}
          ],
          phone: [
            {required: true, message: '请输入电话', trigger: 'blur'}
            // ,{validator: validate.numb, trigger: 'blur'}
          ],
          orgCode: [{required: true, message: '请选择机构', trigger: 'blur'}],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {validator: validate.validatePassword, trigger: 'blur'}
          ],
          confirmPassword: [
            {required: true, message: '请二次输入密码', trigger: 'blur'},
            {validator: this.conformPassword, trigger: 'blur'}
          ],
          realName: [{max: 50, message: '长度不得超过50个字符', trigger: 'blur'}],
          email: [{validator: validate.validateEmail, trigger: 'blur'}],
          qq: [{validator: validate.validateQQ, trigger: 'blur'}],
          province: [{max: 50, message: '长度不得超过50个数字', trigger: 'blur'}],
          liveUrl: [{max: 200, message: '长度不得超过200个字符', trigger: 'blur'}]
        },
        total: 0,
        pageSize: 10,
        currentPage: 1,
        addStaff: false,
        staffData: [],
        isUpdate: false,
        title: '添加用户',
        area: [],
        roleList: [],
        teacherRoleId: [],
        showCourse: false,
        showLiveUrl: false,
        showAgents: false,
        liveUrlRoleId: [],
        courseList: [],
        agentsRoleId: [],
        agentsList: [],
      };
    },
    methods: {
      conformPassword(rule, value, callback) {
        if (this.form.password == value) {
          callback();
        } else {
          callback(new Error('两次密码输入不一致'));
        }
      },
      updateUserState(row) {
        if (row == undefined) {
          this.$message({
            type: 'info',
            message: '操作失败'
          });
        }

        let params = {
          userName: row.userName,
          status: row.status
        };
        this.https
            .fetchPost('/managerUser/updateUserState', params, 'json')
            .then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.$message({
                  type: 'success',
                  message: '操作成功'
                });
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
                if (row.status == 1) {
                  row.status = 2;
                } else {
                  row.status = 1;
                }
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
              if (row.status == 1) {
                row.status = 2;
              } else {
                row.status = 1;
              }
            });
      },
      changeRole(val) {
        this.showCourse = false;
        this.showLiveUrl = false;
        this.showAgents = false;
        console.log(val);
        for (let teacherRole of this.teacherRoleId) {
          for (let roleId of val) {
            if (roleId == teacherRole) {
              this.showCourse = true;
              this.searchCourse();
            }
          }
        }
        for (let liveRole of this.liveUrlRoleId) {
          for (let roleId of val) {
            if (roleId == liveRole) {
              this.showLiveUrl = true;
            }
          }
        }
        for (let agentsRole of this.agentsRoleId) {
          for (let roleId of val) {
            if (roleId == agentsRole) {
              this.showAgents = true;
              this.searchAgents();
            }
          }
        }
        console.log(val);
      },
      handleDialogClose() {
        let that = this;
        this.showCourse = false;
        this.showLiveUrl = false;
        that.form = JSON.parse(JSON.stringify(form));
        that.addStaff = false;
        that.isUpdate = false;
        that.form.userId = '';

        if (that.orgType == 1) {
          that.roleList = [];
        }
        that.$refs['staffForm'].clearValidate();
      },
      changeLecturer() {
      
      },

      searchCourse() {
        let params = {
          orgCode: this.form.orgCode
        };
        this.https.fetchPost('/course/selectCourseByType', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
              console.log(err);
              this.$message.error('网络错误');
        });
      },
      searchAgents() {
        let params = {
        };
        this.https.fetchPost('/managerRole/agents', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.agentsList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      selectOrg() {
        https
            .fetchGet('/managerOrganization/getOrganizationList', '', 'from')
            .then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.org = data.data.data;
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }
            })
            .catch((err) => {
              this.$message.error('网络错误');
            });
      },
      handleSelectionChange(val) {
        this.multipleSelection = [];
        for (let index in val) {
          this.multipleSelection[index] = val[index].userName;
        }
      },
      restPWD(index, row) {
        this.$confirm('此操作将重置该用户信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = row;
          https.fetchPost('/ssoUser/resetPassword', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '重置成功!'
              });
            } else {
              this.$message({
                type: 'info',
                message: '重置失败:' + msg
              });
            }
          })
              .catch((err) => {
                this.$message.error('网络异常！');
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      deleteMore() {
        let roleLength = this.multipleSelection.length;
        this.$confirm('此操作将删除' + roleLength + '条用户信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let multipleSelection = this.multipleSelection;
          let params = multipleSelection;
          https.fetchPost('/ssoUser/deleteUserByUserNameList', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.onSubmit();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败:' + msg
              });
            }
          }).catch((err) => {
            this.$message.error('网络异常！');
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      deleteStaff(index, row) {
        this.$confirm('此操作将删除该用户信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let params = [row.userName];
          https.fetchPost('/ssoUser/deleteUserByUserNameList', params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == '200') {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.onSubmit();
            } else {
              this.$message({
                type: 'info',
                message: '删除失败:' + msg
              });
            }
          }).catch((err) => {
            this.$message.error('网络异常！');
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      onSubmit(val) {
        if (val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.size = this.pageSize;
        let params = this.searchData;
        this.loading = true;
        https.fetchPost('/managerUser/search', JSON.parse(JSON.stringify(params)), 'json').then((data) => {
          let code = data.data.code;
          if (code == '200') {
            this.staffData = data.data.data;
            this.total = data.data.total;
            this.loading = false;
          }
        }).catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error('数据加载失败');
        });
      },
      handleSizeChange() {
      },
      handleCurrentChange(val) {
        this.onSubmit(val);
      },
      updateStaff(index, row) {
        this.title = '修改用户';
        this.form = JSON.parse(JSON.stringify(row));
        this.form.courseIdList = this.form.courseIdIntList;
        this.addStaff = true;
        this.isUpdate = true;
        let courseIds = [];
        this.selectRole();
      },
      saveStaff(formName) {
        this.$refs[formName].validate((valid) => {
          if (!valid) {
            this.$message.error('请正确填写信息！');
            return false;
          } else {
            let url = '/managerUser/addUser';
            if (this.form.userId) {
              url = '/managerUser/updateUser';
            }
            let params = this.form;
            https.fetchPost(url, params).then((data) => {
              console.log(data);
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == '200') {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.addStaff = false;
                this.isUpdate = false;
                this.onSubmit();
                this.form = JSON.parse(JSON.stringify(form));
              } else {
                this.$message.error('操作失败:' + msg);
              }
            }).catch((err) => {
              this.$message.error('网络错误');
            });
          }
        });
      },
      staffStatus(row, column, cellValue, index) {
        if (cellValue == 1) {
          //（1 正常，2停用，3锁定）
          return '正常';
        }
        if (cellValue == 2) {
          return '停用';
        }
        if (cellValue == 2) {
          return '锁定';
        }
        return '其他';
      },
      staffSex(row, column, cellValue, index) {
        if (cellValue == 1) {
          //（性别(0 未知；1女；2男)
          return '女';
        }
        if (cellValue == 2) {
          return '男';
        }

        return '未知';
      },
      searchArea() {
        https.fetchGet('/managerAreas/getAreaTree', '', 'form').then((data) => {
          let code = data.data.code;
          if (code == '200') {
            this.area = data.data.data;
          }
        }).catch((err) => {
          console.log(err);
          this.loading = false;
          this.$message.error('数据加载失败');
        });
      },
      changeOrgAdd(val) {
        this.selectRole();
        this.form.roleIdList = [];
      },

      selectRole() {
        let params = {
          orgCode: this.form.orgCode
        };
        this.showCourse = false;
        this.showLiveUrl = false;
        this.teacherRoleId = [];
        this.liveUrlRoleId = [];
        this.agentsRoleId = [];
        https.fetchPost('/managerRole/getRoleDropDownList', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == '200') {
            this.roleList = data.data.data;
            let roles = [];
            let liveRoles = [];
            let agentsRoles = [];
            for (let role of this.roleList) {
              if (role.roleType == 2) {
                roles.push(role.roleId);
              }
              if (role.roleType == 3) {
                liveRoles.push(role.roleId);
              }
              if (role.roleType == 3) {
                liveRoles.push(role.roleId);
              }
              if (role.roleType == 4) {
                agentsRoles.push(role.roleId);
              }
            }
            this.teacherRoleId = roles;
            this.liveUrlRoleId = liveRoles;
            this.agentsRoleId = agentsRoles;
          } else {
            this.$message.error('获取角色列表失败:' + msg);
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('数据加载失败');
        });
      }
    },
    watch: {
      teacherRoleId: function(val) {
        for (let teacherRole of this.teacherRoleId) {
          for (let roleId of this.form.roleIdList) {
            if (roleId == teacherRole) {
              this.searchCourse();
              this.showCourse = true;
            }
          }
        }
      },
      liveUrlRoleId: function(val) {
        for (let teacherRole of this.liveUrlRoleId) {
          for (let roleId of this.form.roleIdList) {
            if (roleId == teacherRole) {
              this.showLiveUrl = true;
            }
          }
        }
      },
      agentsRoleId: function(val) {
        for (let agentsRole of this.agentsRoleId) {
          for (let roleId of this.form.roleIdList) {
            if (roleId == agentsRole) {
              this.searchAgents();
              this.showAgents = true;
            }
          }
        }
      },
    },

    created: function() {
      this.orgType = this.$store.state.orgType;
      if (this.orgType != 1) {
        this.form.orgCode = this.$store.state.orgCode;
        this.selectRole();
      }
      this.onSubmit();
      this.searchArea();
      this.selectOrg();
    }
  };
</script>

<style>
  .but-cls {
    margin-bottom: 10px;
  }
  
  .cls-col {
    margin-right: 20px;
  }
</style>
